import React from 'react';
import pathfinder from '@fiverr-private/pathfinder';
import { translate } from '@fiverr-private/i18n-react';
import { HEADER_NAV_SOURCE } from '../../../../constants';
import Link from '../../../Links/Link';

export const SupportLink = () => (
    <Link
        href={pathfinder('support_get_help_page', {}, { query: { source: HEADER_NAV_SOURCE } })}
        target="_blank"
        className="nav-link"
    >
        {translate('header.support')}
    </Link>
);
